import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@/axios";
import { routes } from "@/utils/urls";

export interface PcpResponse {
  status: number;
  data: {
    memberPcpName: string;
    memberPcpPhone: string;
    memberPcpAddress1: string;
    memberPcpAddress2: string;
    memberPcpCity: string;
    memberPcpState: string;
  };
}

export interface PcpState {
  byMemberId: Record<string, PcpResponse["data"] | undefined>;
  loading: boolean;
  error: string | null;
}

const initialState: PcpState = {
  byMemberId: {},
  loading: false,
  error: null,
};

const PCP_DUMMY: PcpResponse = {
  status: 200,
  data: {
    memberPcpName: "lsejfhbaivsfkjvnaDr. Sarah Johnson",
    memberPcpPhone: "999-0201",
    memberPcpAddress1: "700 Medical Plaza",
    memberPcpAddress2: "Floor 3 dummy data",
    memberPcpCity: "New York city",
    memberPcpState: "NY dummy data",
  },
};

export const fetchPcp = createAsyncThunk<
  { memberId: string; data: PcpResponse["data"] },
  { memberId: string },
  { rejectValue: string }
>(
  "pcpByMemberId/fetch",
  async ({ memberId }, { rejectWithValue }) => {
    try {
      try {
        const res = await api.get(`${routes.cards.pcp}/${memberId}`);
        const data = res.data as PcpResponse;
        if (data && data.data) {
          return { memberId, data: data.data };
        }
      } catch (_e) {
        // fall back to dummy
      }
      return { memberId, data: PCP_DUMMY.data };
    } catch (_e) {
      return rejectWithValue("Failed to fetch PCP");
    }
  }
);

const pcpSlice = createSlice({
  name: "pcpByMemberId",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPcp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPcp.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.byMemberId[action.payload.memberId] = action.payload.data;
      })
      .addCase(fetchPcp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch PCP";
      });
  },
});

export default pcpSlice.reducer;


